import { Skeleton } from '@natu/ui/Skeleton';

export const ArticleShowcaseSkeleton = () => {
  return (
    <ul className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3 lg:gap-y-10">
      {Array.from({ length: 6 }).map((_, index) => (
        <li key={`article-showcase-skeleton-item-${index}`}>
          <Skeleton className="mb-6 aspect-[311/223]" />
          <Skeleton className="mb-4 h-[22px]" />
          <Skeleton className="mb-6 h-14" />
          <Skeleton className="mb-6 h-[72px]" />
          <Skeleton className="h-6 w-44" />
        </li>
      ))}
    </ul>
  );
};
